export const tokenKey = 'token';
export const roleKey = 'role';

export enum USER_ROLES {
  ADMIN = 'ADMIN',
  LEAD = 'LEAD',
  AGENT = 'AGENT',
  ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
  // SDR — Sales Development Rep. Has admin-panel access but only to
  // /admin/masterclass (funnel analytics + lead conversion) and
  // /admin/users (lead/member management). Everything else in the
  // admin nav is hidden + protected via is-admin middleware role
  // gating.
  SDR = 'SDR',
}

export enum USER_STATUSES {
  REGISTERED = 'REGISTERED',
  MEMBER = 'MEMBER',
}

export enum REFUND_STATUSES {
  ELIGIBLE = 'ELIGIBLE',
  DUE = 'DUE',
  CONFIRMED = 'CONFIRMED',
}

export enum ACCESS_LEVELS {
  BASIC = 'BASIC',
  SILVER = 'SILVER',
  GOLD = 'GOLD',
  BLACK = 'BLACK',
}
